
import TiwiMixin from '../mixins/TiwiMixin';
import ModalPopup from './ModalPopup';
import ReviewCard from './ReviewCard.vue'

export default {
  mixins: [TiwiMixin],
  components: {
    ModalPopup,
    ReviewCard
  },
  props: {
    relatedId: {
      required: true
    },
    relatedType: {
      required: false,
      default: 'post'
    }
  },
  mounted: function () {
    this.showModal = false;
    this.loadReviews();
  },
  data() {
    return {
      showModal: false,
      post_reviews: [],
      can_review: false,
      rating_info: { rating: null, review: '' }
    }
  },
  methods: {
    onClose: function () {
      this.toggleModal(false);
    },
    setRating: function (rating) {
      this.rating_info.rating = rating;
    },
    publishReview: function () {
      // this.rating_info.rating = rating;
      const self = this;
      
      self.setLoading(false);

      if (!this.rating_info.rating) {
        self.toast.warning('Seleziona almeno una stella!');
        return;
      }

      const post_data = { 
        type: 'REVIEW', 
        related_id: this.relatedId, 
        related_type: this.relatedType, 
        active: true,
        data: this.rating_info
      };

      this.api.post('user-event/toggle', post_data)
        .then((response) => {
          if (response.data.success) {
            this.loadReviews();
            self.toast.success('La recensione è stata aggiunta con successo!');
            this.toggleModal(false);
            this.can_review = false;
          } else {
            self.toast.error(response.data.message);
          }
        })
        .catch((error) => {
          self.toast.error('Errore nella richiesta');
        })
        .finally(() => self.setLoading(false))
    },
    loadReviews() {
      const self = this;

      const post_data = { 
        event_type: 'REVIEW', 
        related_id: this.relatedId, 
        related_type: this.relatedType,
        user_data: true
      };

      this.api.post('user-event/postEvents', post_data)
        .then((response) => {
          if (response.data.success) {
            self.post_reviews = response.data.post_events;
          } else {
            console.error(response.data.message);
          }
        })
        .catch((error) => {
          self.toast.error('Errore nella richiesta');
        })
        .finally(() => self.setLoading(false))
    },
    toggleModal: function (status) {
      this.showModal = status;
    }
  },
  watch: {
    user_activity: function(activity) {
      if (activity && !(activity?.REVIEW?.post && Object.values(activity?.REVIEW?.post).includes(parseInt(this.relatedId)))) {
        this.can_review = true;
      }
    }
  }
}
